var _defs, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRequirements = function SvgRequirements(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Requirements_svg__aa2a8f6d-e98d-4a58-95bc-066edd48b612{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Requirements_svg__f26c8fa8-7442-45ac-a873-d285dcd85b76",
    "data-name": "Requirements"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h250v250H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Requirements_svg__aa2a8f6d-e98d-4a58-95bc-066edd48b612",
    d: "M49.36 137.37h89.18v19.07h0-89.18a8.31 8.31 0 0 1-8.31-8.31v-2.46a8.31 8.31 0 0 1 8.31-8.3Z",
    transform: "rotate(-30 89.793 146.92)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Requirements_svg__aa2a8f6d-e98d-4a58-95bc-066edd48b612",
    transform: "rotate(-30 137.355 119.444)",
    d: "M131.18 113.27h12.36v12.36h-12.36z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Requirements_svg__aa2a8f6d-e98d-4a58-95bc-066edd48b612",
    d: "m142.71 116.36 9.69-5.59M58.26 154.1l9.54 16.52M100.65 129.62V57.26H180.81l23.34 24.75v110.74h-103.5v-41.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Requirements_svg__aa2a8f6d-e98d-4a58-95bc-066edd48b612",
    d: "M180.7 57.25v25.39h23.45"
  }))));
};

export default SvgRequirements;